import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, ComboLookUpValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class ComboLookUpHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    // å¸®å©çqc.comparetypeåªæç­äºãä¸ç­äº
    const cluv = (qc.value as ComboLookUpValue);
    if (cluv.value.length == 0 || !cluv.valueField) {
      return [];
    } else {
      const arr = [];
      cluv.getOriginalValue().split(',').forEach((id) => {
        id && arr.push({
          'FilterField': qc.fieldCode,
          'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Equal,
          'Value': id,
          'Relation': qc.compareType === CompareType.NotEqual ? RelationType.And : RelationType.Or,
          'Expresstype': ValueType.Value
        });
      });
      if (arr.length > 0) {
        arr[0]['Lbracket'] = qc.Lbracket ? (qc.Lbracket + '(') :'(';
        arr[arr.length -1]['Rbracket'] = qc.Rbracket ? (qc.Rbracket + ')') : ')';
        arr[arr.length - 1]['Relation'] = (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And;
        return arr;
      } else {
        return [];
      }
    }
  }
}
